import createReactClass from "create-react-class";

export default function(dependencies) {

    const html = createReactClass({
        render() {
            var [days, hours, minutes, seconds] = timeUntil(this.state.secondsLeft);

            return <div className="lz-input-wrapper">
                <div className="lz-limited-offer">
                    <span className="lz-ticker">{days}</span>
                    <span className="lz-ticker">{hours}</span>
                    <span className="lz-ticker">{minutes}</span>
                    <span className="lz-ticker">{seconds}</span>
                </div>
            </div>;
        },
        getInitialState() {
            return {
                secondsLeft: secondsUntil(this.props.field.config.defaultValue)
            };
        },
        componentDidMount() {
            var updateTime = (function () {
                this.setState({
                    secondsLeft: secondsUntil(this.props.field.config.defaultValue)
                });
                setTimeout(updateTime, 1000);
            }).bind(this);

            updateTime();
        }
    });

    var config = {
        ignored: true
    };

    return {
        html: html,
        config: config
    };
};

function secondsUntil(until) {
    // var [day, month, year, hour, minute] = splitDate(until);
    
    var target = new Date(until);
    var secondsLeft = (target.getTime() - Date.now()) / 1000;

    return secondsLeft < 0 ? 0 : secondsLeft;
}

function timeUntil(millis) {
    var divisors = [1, 24, 60, 60];

    return divisors.reduce(({remainingTime, list}, divisor) => {
        var wholeUnits = Math.floor(remainingTime * divisor);

        return {
            remainingTime: remainingTime * divisor - wholeUnits,
            list: list.concat([wholeUnits])
        };
    }, {
        remainingTime: millis / divisors.reduce((left, right) => left * right),
        list: []
    }).list;
}

function splitDate(date) {
    return [2,1,2,1,4,1,2,1,2].reduce(({remainingText, list}, length) => {
        return {
            remainingText: remainingText.slice(length),
            list: list.concat(remainingText.slice(0, length))
        };
    }, {remainingText: String(date), list: []}).list.filter(part => {
        var toRemove = ["-", " ", ":"];
        return toRemove.indexOf(part) === -1;
    }).map(Number);
}
